export default __webpack_public_path__ + "static/media/truck_color.63706394.svg";